import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';

export interface AutoRolloverData {
  enrolledStatus?: string;
  enrolledBy?: string;
  enrolledon?: string;
  enrolledDate?: string;
}

@Component({
  selector: 'app-custom-autorollover',
  standalone: false,
  templateUrl: './custom-autorollover.component.html',
  styleUrls: ['./custom-autorollover.component.scss'],
})
export class CustomAutorolloverComponent {
  toggleEdit: boolean = false;
  userARRData!: AutoRolloverData;
  isPreBookEnabled: boolean = false;
  @Input() cmsContent: any;

  constructor(
    private userInfoService: UserInfoService,
    private cdr: ChangeDetectorRef
  ) {}

  toggleEditAutoRollover() {
    this.toggleEdit = !this.toggleEdit;
  }
  disableAutoRollover() {
    this.userInfoService
      .updateAutoRolloverEnrollStatus(false)
      .subscribe((data: any) => {
        this.fetchAutoRolloverStatus();
        this.toggleEdit = false;
        this.userInfoService.setAutoRollOverAlert(false)
        this.cdr.detectChanges();
      });
  }
  fetchAutoRolloverStatus() {
    this.userInfoService
      .getAutoRolloverEnrollStatus()
      .subscribe((data: any) => {
        this.userARRData = data;
        this.cdr.detectChanges();
      });
  }

  ngOnInit() {
    this.fetchAutoRolloverStatus();
  }
}
